import { ChannelType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredString } from '@/utils/zodUtils';

export const ChannelConfigurationFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      description: requiredString(t),
      type: requiredEnum(ChannelType, t),
    })
    .strict();

export type ChannelConfigurationFormType = z.infer<ReturnType<typeof ChannelConfigurationFormSchema>>;
